<template lang="pug">
v-card(data-test="exam-modal")
  v-card-title 
    v-btn(icon color="black" @click="$emit('back')")
      v-icon mdi-arrow-left
    span {{ title }}
  v-divider
  v-card-text
    examBody(
      :formData="formData"
      :formErrors="formErrors"
      :showing="showing"
      :currentDate="currentDate"
      :getExamLocation="getExamLocation"
    )

  v-divider
  v-card-actions
    slot(name="actions" :formData="formData")
      v-spacer
      v-btn(outlined width="80") Cancel
      v-btn(color="primary" width="80" data-test="exam-create") Add
</template>

<script>
import { convertToDefaultBackendFormat, convertToDefaultDateFormat, dateFormatingFromBackend } from '@/util'
import {mapActions} from "vuex"
export default {
  name: 'ExamModalBody',
  props: {
    courseDate: String,
    formErrors: Object,
    editData: Object,
    showing: Boolean,
    title: String
  },
  data: () => ({
    formData: {
      location: '',
      timeFrom: '',
      timeTo: '',
      date: ''
    },
    currentDate: convertToDefaultBackendFormat(new Date(Date.now())),
  }),

  mounted() {
    this.loadDefaultFormData()
  },

  methods: {
    ...mapActions({
      getExamLocation: 'crmExamLocation/list',
    }),
    loadDefaultFormData() {
      Object.assign(this.formData, this.editData,
                    { date: this.courseDate ? this.courseDate : dateFormatingFromBackend(this.editData.date) })
    },

    setStudentsQuantity(field, val) {
      this.formData[field] = +val
    }
  },

  watch: {
    showing: {
      handler: function(isShowing) {
        // if(isShowing) this.loadDefaultFormData()
      }
      
    }
  },

  components:{ 
    examBody: () => import('./CmExamBody.vue')
  }
}
</script>